<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ isView ? "View " : $route.params.id ? "Edit " : "Add " }} School
            Staff
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <fieldset :disabled="isView">
      <form @submit.prevent="saveInstructor">
        <!-- Details -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0"><h3>Details</h3></div>
              <div class="card-body">
                <div
                  class="form-row"
                  v-if="tokenObj.UserType == userTypeMainAdmin"
                >
                  <div class="form-group col-md-6">
                    <label>School<span class="text-danger">*</span></label>
                    <select
                      class="form-control"
                      v-model="schoolId"
                      required
                      @change="onChangeSchool($event)"
                    >
                      <option value>-- Please Select School --</option>
                      <option
                        v-for="item in schools"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>User Type<span class="text-danger">*</span></label>
                    <div class="form-row">
                      <div :class="showUserTypeOthers ? 'col-5' : 'col-12'">
                        <select
                          class="form-control"
                          v-model="userTypeId"
                          required
                          @change="onChangeUserType($event)"
                        >
                          <option value>-- Please Select User Type --</option>
                          <option
                            v-for="item in userTypes"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-7" v-if="showUserTypeOthers">
                        <input
                          type="text"
                          v-model="userTypeOthers"
                          class="form-control"
                          placeholder="Input Other User Type Here"
                          maxlength="50"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <div class="form-row">
                      <div class="col-5">
                        <label>
                          Join Date<span class="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          v-model="joinDate"
                          class="form-control"
                          required
                        />
                      </div>
                      <div class="col-7">
                        <label>Length of Service (Years)</label>
                        <input
                          type="number"
                          v-model="lengthOfService"
                          class="form-control"
                          maxlength="99"
                          min="0"
                          step="0.1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6 id-div">
                    <label>ID<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="username"
                      class="form-control"
                      placeholder="Input ID Here"
                      maxlength="50"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label style="line-height: 15px">
                      Password
                      <span class="note">
                        (must be minimum of 6 characters with combination of
                        upper and lower case letters, numbers, and
                        non-alphanumeric symbols)
                      </span>
                    </label>
                    <input
                      type="text"
                      v-model="password"
                      class="form-control"
                      placeholder="Password"
                      maxlength="50"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Name<span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="name"
                      class="form-control"
                      placeholder="Input Name Here"
                      maxlength="100"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      v-model="dateOfBirth"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Gender</label>
                    <div class="form-row">
                      <div :class="showGenderCustom ? 'col-5' : 'col-12'">
                        <select
                          class="form-control"
                          v-model="genderId"
                          @change="onChangeGender($event)"
                        >
                          <option value>-- Please Select Gender --</option>
                          <option
                            v-for="item in genders"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-7" v-if="showGenderCustom">
                        <input
                          type="text"
                          v-model="genderCustom"
                          class="form-control"
                          placeholder="Input Custom Gender Here"
                          maxlength="50"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Nationality</label>
                    <select class="form-control" v-model="nationalityId">
                      <option value>-- Please Select Nationality --</option>
                      <option
                        v-for="item in nationalities"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Citizenship</label>
                    <div class="form-row">
                      <div :class="showCitizenshipOther ? 'col-5' : 'col-12'">
                        <select
                          class="form-control"
                          v-model="citizenshipOtherNationalityId"
                          @change="onChangeCitizenship($event)"
                        >
                          <option value>-- Please Select Citizenship --</option>
                          <option
                            v-for="item in nationalities"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-7" v-if="showCitizenshipOther">
                        <select
                          class="form-control"
                          v-model="citizenshipOtherNationalityId"
                          required
                        >
                          <option value>-- Please Select Nationality --</option>
                          <option
                            v-for="item in nationalities"
                            :value="item.Id"
                            :key="item.Id"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Country of Work</label>
                    <v-select
                      multiple
                      :options="countries"
                      label="Name"
                      v-model="userCountries"
                      class="vselect"
                      placeholder="-- Please Select Country of Work --"
                      :disabled="isView"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Document Number</label>
                    <input
                      type="text"
                      v-model="documentNumber"
                      class="form-control"
                      placeholder="Input Document Number Here"
                      maxlength="50"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Marital Status</label>
                    <select class="form-control" v-model="maritalStatusId">
                      <option value>-- Please Select Marital Status --</option>
                      <option
                        v-for="item in maritalStatuses"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Details -->

        <!-- Contact Information  -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Contact Information</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Email<span class="text-danger">*</span></label>
                    <div class="table-responsive">
                      <table class="table table-bordered email-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="email-col">Email</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addEmail"
                              >
                                <i class="fa fa-plus" title="Add Email"></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(email, i) in emails" :key="i">
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="email.EmailTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeEmailType($event, i)"
                              >
                                <option
                                  v-for="item in emailTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="email.EmailTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="email.ShowEmailTypeOther"
                              />
                            </td>
                            <td class="email-col">
                              <input
                                type="email"
                                v-model="email.Email"
                                class="form-control form-control-sm"
                                placeholder="Email"
                                required
                                maxlength="100"
                              />
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeEmail(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Email"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label>
                      Contact Number<span class="text-danger">*</span>
                    </label>
                    <div class="table-responsive">
                      <table class="table table-bordered contact-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="phone-col">Phone</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addContactNumber"
                              >
                                <i class="fa fa-plus" title="Add Phone"></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(contactNumber, i) in contactNumbers"
                            :key="i"
                          >
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="contactNumber.ContactNumberTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeContactNumberType($event, i)"
                              >
                                <option
                                  v-for="item in contactNumberTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="contactNumber.ContactNumberTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="contactNumber.ShowContactNumberTypeOther"
                              />
                            </td>
                            <td class="phone-col">
                              <input
                                type="text"
                                v-model="contactNumber.Phone"
                                class="form-control form-control-sm"
                                placeholder="Phone"
                                maxlength="20"
                                required
                              />
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeContactNumber(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Phone"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Address</label>
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="street-col">Street 1</th>
                            <th class="street-col">Street 2</th>
                            <th class="city-col">City</th>
                            <th class="postcode-col">Postcode</th>
                            <th class="country-col">Country</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addAddress"
                              >
                                <i class="fa fa-plus" title="Add Address"></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(address, i) in addresses" :key="i">
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="address.AddressTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeAddressType($event, i)"
                              >
                                <option
                                  v-for="item in addressTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="address.AddressTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="address.ShowAddressTypeOther"
                              />
                            </td>
                            <td class="street-col">
                              <textarea
                                v-model="address.Street1"
                                class="form-control"
                                placeholder="Street"
                                maxlength="100"
                              ></textarea>
                            </td>
                            <td class="street-col">
                              <textarea
                                v-model="address.Street2"
                                class="form-control"
                                placeholder="Street"
                                maxlength="100"
                              ></textarea>
                            </td>
                            <td class="city-col">
                              <input
                                type="text"
                                v-model="address.City"
                                class="form-control form-control-sm"
                                placeholder="City"
                                maxlength="50"
                              />
                            </td>
                            <td class="postcode-col">
                              <input
                                type="text"
                                v-model="address.Postcode"
                                class="form-control form-control-sm"
                                placeholder="Postcode"
                                maxlength="20"
                              />
                            </td>
                            <td class="country-col">
                              <select
                                v-model="address.CountryId"
                                class="form-control form-control-sm"
                                required
                              >
                                <option
                                  v-for="item in countries"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeAddress(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Address"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="false">
                  <div class="form-group col-md-12">
                    <label>Bank Details</label>
                    <div class="table-responsive">
                      <table class="table table-bordered bank-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="type-col">Type</th>
                            <th class="bankname-col">Bank Name</th>
                            <th class="bankaccount-col">Bank Account</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addBank"
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Bank Account"
                                ></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(bank, i) in banks" :key="i">
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="type-col">
                              <select
                                v-model="bank.BankAccountTypeId"
                                class="form-control form-control-sm"
                                required
                                @change="onChangeBankAccountType($event, i)"
                              >
                                <option
                                  v-for="item in bankAccountTypes"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="bank.BankAccountTypeOther"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="50"
                                v-if="bank.ShowBankAccountTypeOther"
                              />
                            </td>
                            <td class="bankname-col">
                              <input
                                type="text"
                                v-model="bank.BankName"
                                class="form-control form-control-sm"
                                placeholder="Bank Name"
                                maxlength="100"
                              />
                            </td>
                            <td class="bankaccount-col">
                              <input
                                type="text"
                                v-model="bank.BankAccount"
                                class="form-control form-control-sm"
                                placeholder="Bank Account"
                                maxlength="100"
                              />
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeBank(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Bank Account"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Contact Information  -->

        <!-- Instructor Expertise -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Instructor's Expertise</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-7">
                    <label>Specialisation</label>
                    <div class="table-responsive">
                      <table class="table table-bordered specialisation-table">
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th class="specialisation-col">Specialisation</th>
                            <th class="qualification-col">Qualification</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addSpecialisation"
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Specialisation"
                                ></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(specialisation, i) in specialisations"
                            :key="i"
                          >
                            <td class="no-col">{{ i + 1 }}</td>
                            <td class="specialisation-col">
                              <select
                                v-model="specialisation.SubjectId"
                                class="form-control form-control-sm"
                                :required="specialisation.QualificationId != ''"
                                @change="onChangeSpecialisation($event, i)"
                              >
                                <option value>
                                  -- Please Select Specialisation --
                                </option>
                                <option
                                  v-for="item in specialisationSubjects"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="specialisation.SubjectOthers"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="100"
                                placeholder="Input Other Specialisation Here"
                                v-if="specialisation.ShowSubjectOthers"
                              />
                            </td>
                            <td class="qualification-col">
                              <select
                                v-model="specialisation.QualificationId"
                                class="form-control form-control-sm"
                                :required="specialisation.SubjectId != ''"
                                @change="onChangeQualification($event, i)"
                              >
                                <option value>
                                  -- Please Select Qualification --
                                </option>
                                <option
                                  v-for="item in qualifications"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                              <input
                                type="text"
                                v-model="specialisation.QualificationOthers"
                                class="form-control form-control-sm mt-2"
                                required
                                maxlength="100"
                                placeholder="Input Other Qualification Here"
                                v-if="specialisation.ShowQualificationOthers"
                              />
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removeSpecialisation(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Specialisation"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="form-group col-md-5">
                    <label>Preferred Teaching Subject</label>
                    <div class="table-responsive">
                      <table
                        class="table table-bordered preferredteaching-table"
                      >
                        <thead class="thead-light">
                          <tr>
                            <th class="no-col">#</th>
                            <th>Teaching Subject</th>
                            <th class="action-col">
                              <button
                                type="button"
                                class="btn btn-primary"
                                @click="addPreferredTeachingSubject"
                              >
                                <i
                                  class="fa fa-plus"
                                  title="Add Preferred Teaching Subject"
                                ></i>
                              </button>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              preferredTeachingSubject, i
                            ) in preferredTeachingSubjects"
                            :key="i"
                          >
                            <td class="no-col">{{ i + 1 }}</td>
                            <td>
                              <select
                                v-model="preferredTeachingSubject.SubjectId"
                                class="form-control form-control-sm"
                              >
                                <option value>
                                  -- Please Select Preferred Teaching Subject --
                                </option>
                                <option
                                  v-for="item in teachingSubjects"
                                  :value="item.Id"
                                  :key="item.Id"
                                >
                                  {{ item.Name }}
                                </option>
                              </select>
                            </td>
                            <td class="action-col">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="removePreferredTeachingSubject(i)"
                              >
                                <i
                                  class="fa fa-trash-o"
                                  title="Remove Preferred Teaching Subject"
                                ></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <div class="table-responsive">
                      <table class="table teachinglevel-table">
                        <thead class="thead-light">
                          <tr>
                            <th>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="checkAllPreferredTeachingLevel"
                                  @change="
                                    onChangeCheckAllPreferredTeachingLevel(
                                      $event
                                    )
                                  "
                                />
                                <label class="mt-2 ml-2">
                                  Preferred Teaching Level
                                </label>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(teachingLevel, i) in teachingLevels"
                            :key="i"
                          >
                            <td>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="teachingLevel.IsSelected"
                                  :id="teachingLevel.Id"
                                  @change="onChangeCheckPreferredTeachingLevel"
                                />
                                <label
                                  :for="teachingLevel.Id"
                                  class="mt-2 ml-2"
                                >
                                  {{ teachingLevel.Name }}
                                </label>
                                <input
                                  type="text"
                                  v-model="teachingLevel.SubjectLevelOthers"
                                  class="form-control form-control-sm ml-4"
                                  required
                                  maxlength="100"
                                  placeholder="Input Other Teaching Level Here"
                                  v-if="
                                    teachingLevel.IsSelected &&
                                    teachingLevel.Name == 'Others'
                                  "
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <div class="table-responsive">
                      <table class="table duration-table">
                        <thead class="thead-light">
                          <tr>
                            <th>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="checkAllPreferredDuration"
                                  @change="
                                    onChangeCheckAllPreferredDuration($event)
                                  "
                                />
                                <label class="mt-2 ml-2">
                                  Preferred Class Duration
                                </label>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(duration, i) in durations" :key="i">
                            <td>
                              <div class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  v-model="duration.IsSelected"
                                  :id="duration.Id"
                                  @change="onChangeCheckPreferredDuration"
                                />
                                <label :for="duration.Id" class="mt-2 ml-2">
                                  {{ duration.Duration }}
                                </label>
                                <input
                                  type="text"
                                  v-model="duration.DurationOthers"
                                  class="form-control form-control-sm ml-4"
                                  required
                                  maxlength="20"
                                  placeholder="Input Other Class Duration Here"
                                  v-if="
                                    duration.IsSelected &&
                                    duration.Duration == 'Others'
                                  "
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Instructor Expertise -->

        <!-- Others -->
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center pb-0">
                <h3>Others</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Status</label>
                    <select v-model="status" class="form-control" required>
                      <option value="Active" selected>Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Remarks</label>
                    <textarea
                      class="form-control"
                      v-model="remarks"
                      maxlength="500"
                      placeholder="Input Remarks Here"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Others -->

        <!-- Button -->
        <div class="text-center" v-if="!isView">
          <router-link
            class="btn btn-danger mr-4"
            :to="{
              name:
                tokenObj.UserType == userTypeMainAdmin
                  ? 'mainAdminInstructorList'
                  : 'schoolAdminInstructorList',
            }"
          >
            Cancel
          </router-link>
          <button class="btn btn-primary" type="submit">
            {{ $route.params.id ? "Update " : "Add " }}
          </button>
        </div>
        <!-- /Button -->
      </form>
    </fieldset>
    <!-- Button Back -->
    <div class="text-center" v-if="isView">
      <router-link
        class="btn btn-primary"
        :to="{
          name:
            tokenObj.UserType == userTypeMainAdmin
              ? 'mainAdminInstructorList'
              : 'schoolAdminInstructorList',
        }"
      >
        <i class="fa fa-reply mr-2"></i>Back to School Staff
      </router-link>
    </div>
    <!-- /Button Back -->
  </div>
</template>


<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      //details
      schoolId: "",
      schools: [],
      isSchoolAdmin: false,
      userTypeId: "",
      userTypes: [],
      showUserTypeOthers: false,
      userTypeOthers: "",
      joinDate: "",
      lengthOfService: null,
      username: "",
      password: "",
      name: "",
      dateOfBirth: "",
      genderId: "",
      genders: [],
      genderCustom: "",
      showGenderCustom: false,
      nationalityId: "",
      nationalities: [],
      citizenshipId: "",
      citizenships: [],
      showCitizenshipOther: false,
      citizenshipOtherNationalityId: "",
      userCountries: [],
      documentNumber: "",
      maritalStatusId: "",
      maritalStatuses: [],
      //contact information
      //--email--
      emails: [
        {
          Id: "",
          EmailTypeId: "",
          EmailTypeOther: "",
          ShowEmailTypeOther: false,
          Email: "",
          SortOrder: "",
        },
      ],
      emailTypes: [],
      //--address--
      addresses: [
        {
          Id: "",
          AddressTypeId: "",
          ShowAddressTypeOther: false,
          AddressTypeOther: "",
          Street1: "",
          Street2: "",
          City: "",
          Postcode: "",
          CountryId: "",
          SortOrder: "",
        },
      ],
      addressTypes: [],
      countries: [],
      //--contact number--
      contactNumbers: [
        {
          Id: "",
          ContactNumberTypeId: "",
          ShowContactNumberTypeOther: false,
          ContactNumberTypeOther: "",
          Phone: "",
        },
      ],
      contactNumberTypes: [],
      //--bank--
      banks: [
        {
          Id: "",
          BankAccountTypeId: "",
          ShowBankAccountTypeOther: false,
          BankAccountTypeOther: "",
          BankName: "",
          BankAccount: "",
        },
      ],
      bankAccountTypes: [],
      //instructor expertise
      //--specialisation
      specialisations: [
        {
          Id: "",
          SubjectId: "",
          SubjectOthers: "",
          ShowSubjectOthers: false,
          QualificationId: "",
          QualificationOthers: "",
          ShowQualificationOthers: false,
        },
      ],
      specialisationSubjects: [],
      qualifications: [],
      //--preferred teaching subject
      preferredTeachingSubjects: [
        {
          Id: "",
          SubjectId: "",
        },
      ],
      teachingSubjects: [],
      //--preferred teaching level
      teachingLevels: [],
      checkAllPreferredTeachingLevel: false,
      //--preferred class duration
      durations: [],
      checkAllPreferredDuration: false,
      //--others
      status: "Active",
      remarks: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isView() {
      return this.$route.path.includes("/show");
    },
  },
  watch: {
    joinDate(val) {
      if (val) {
        let joinDate = new Date(val);
        let todayDate = new Date();
        let yearDiff = (todayDate - joinDate) / (1000 * 60 * 60 * 24 * 365.25);
        let yearDiffRounded = yearDiff <= 0 ? 0 : yearDiff.toFixed(1);
        this.lengthOfService =
          parseFloat(yearDiffRounded) % 1 === 0
            ? parseInt(yearDiffRounded)
            : parseFloat(yearDiffRounded);
      } else {
        this.lengthOfService = null;
      }
    },
  },
  methods: {
    //for details section
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSchool(event) {
      //reset user type
      this.userTypeId = "";
      this.showUserTypeOthers = false;
      this.userTypeOthers = "";
      //reset specialisation and qualification
      this.specialisationSubjects = [];
      this.qualifications = [];
      this.specialisations = [
        {
          Id: "",
          SubjectId: "",
          SubjectOthers: "",
          ShowSubjectOthers: false,
          QualificationId: "",
          QualificationOthers: "",
          ShowQualificationOthers: false,
        },
      ];
      //reset teaching subject
      this.teachingSubjects = [];
      this.preferredTeachingSubjects = [
        {
          Id: "",
          SubjectId: "",
        },
      ];
      //reset teaching level
      this.checkAllPreferredTeachingLevel = false;
      this.teachingLevels = [];
      //populate data
      let schoolId = event.target.value;
      if (schoolId) {
        this.getSpecialisationSubjectsForInstructor(schoolId);
        this.getInstructorUserTypes(schoolId);
        this.getSchoolQualifications(schoolId);
        this.getTeachingSubjectsForInstructor(schoolId);
        this.getTeachingLevelsForInstructor(schoolId);
      }
    },
    getInstructorUserTypes(schoolId) {
      API.instructor
        .getInstructorUserTypes({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.userTypes = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeUserType(event) {
      let userTypeId = event.target.value;
      let userType = this.userTypes.find((c) => c.Id == userTypeId);
      this.showUserTypeOthers = userType && userType.Name == "Others";
    },
    getGenders() {
      API.common
        .getGenders({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.genders = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeGender(event) {
      let genderId = event.target.value;
      let gender = this.genders.find((c) => c.Id == genderId);
      this.showGenderCustom = gender && gender.Name == "Custom";
    },
    getNationalities() {
      API.common
        .getNationalities({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.nationalities = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getCitizenships() {
      API.common
        .getCitizenships({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.citizenships = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCitizenship(event) {
      let citizenshipId = event.target.value;
      let citizenship = this.citizenships.find((c) => c.Id == citizenshipId);
      this.showCitizenshipOther = citizenship && citizenship.Name == "Other";
    },
    getMaritalStatuses() {
      API.common
        .getMaritalStatuses({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.maritalStatuses = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //for contact information section
    //email
    getEmailTypesForInstructor() {
      API.instructor
        .getEmailTypesForInstructor({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.emailTypes = response.data.data;
            if (!this.$route.params.id)
              this.emails[0].EmailTypeId = this.emailTypes[0].Id;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeEmailType(event, index) {
      let emailTypeId = event.target.value;
      let emailType = this.emailTypes.find((c) => c.Id == emailTypeId);
      this.emails[index].ShowEmailTypeOther =
        emailType && emailType.Name == "Other";
    },
    removeEmail(index) {
      this.emails.splice(index, 1);
    },
    addEmail() {
      this.emails.push({
        Id: "",
        EmailTypeId: this.emailTypes[0].Id,
        EmailTypeOther: "",
        ShowEmailTypeOther: false,
        Email: "",
        SortOrder: "",
      });
    },
    //address
    getAddressTypesForInstructor() {
      API.instructor
        .getAddressTypesForInstructor({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.addressTypes = response.data.data;
            if (!this.$route.params.id)
              this.addresses[0].AddressTypeId = this.addressTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getCountries() {
      API.common
        .getCountries({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            if (!this.$route.params.id)
              this.addresses[0].CountryId = this.countries.find(
                (c) => c.Name == "Singapore"
              ).Id;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeAddressType(event, index) {
      let addressTypeId = event.target.value;
      let addressType = this.addressTypes.find((c) => c.Id == addressTypeId);
      this.addresses[index].ShowAddressTypeOther =
        addressType && addressType.Name == "Other";
    },
    removeAddress(index) {
      this.addresses.splice(index, 1);
    },
    addAddress() {
      this.addresses.push({
        Id: "",
        AddressTypeId: this.addressTypes[0].Id,
        ShowAddressTypeOther: false,
        AddressTypeOther: "",
        Street1: "",
        Street2: "",
        City: "",
        Postcode: "",
        CountryId: this.countries.find((c) => c.Name == "Singapore").Id,
        SortOrder: "",
      });
    },
    //contact number
    getContactNumberTypesForInstructor() {
      API.instructor
        .getContactNumberTypesForInstructor({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.contactNumberTypes = response.data.data;
            if (!this.$route.params.id)
              this.contactNumbers[0].ContactNumberTypeId =
                this.contactNumberTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeContactNumberType(event, index) {
      let contactNumberTypeId = event.target.value;
      let contactNumberType = this.contactNumberTypes.find(
        (c) => c.Id == contactNumberTypeId
      );
      this.contactNumbers[index].ShowContactNumberTypeOther =
        contactNumberType && contactNumberType.Name == "Other";
    },
    removeContactNumber(index) {
      this.contactNumbers.splice(index, 1);
    },
    addContactNumber() {
      this.contactNumbers.push({
        Id: "",
        ContactNumberTypeId: this.contactNumberTypes[0].Id,
        ContactNumberTypeOther: "",
        ShowContactNumberTypeOther: false,
        Phone: "",
      });
    },
    //bank
    getBankAccountTypes() {
      API.common
        .getBankAccountTypes({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.bankAccountTypes = response.data.data;
            if (!this.$route.params.id)
              this.banks[0].BankAccountTypeId = this.bankAccountTypes[0].Id;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeBankAccountType(event, index) {
      let bankAccountTypeId = event.target.value;
      let bankAccountType = this.bankAccountTypes.find(
        (c) => c.Id == bankAccountTypeId
      );
      this.banks[index].ShowBankAccountTypeOther =
        bankAccountType && bankAccountType.Name == "Other";
    },
    removeBank(index) {
      this.banks.splice(index, 1);
    },
    addBank() {
      this.banks.push({
        Id: "",
        BankAccountTypeId: this.bankAccountTypes[0].Id,
        ShowBankAccountTypeOther: false,
        BankAccountTypeOther: "",
        BankName: "",
        BankAccount: "",
      });
    },
    //for musical expertise
    //specialisation
    getSpecialisationSubjectsForInstructor(schoolId) {
      API.subject
        .getSpecialisationSubjectsForInstructor({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.specialisationSubjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSpecialisation(event, index) {
      let subjectId = event.target.value;
      let subject = this.specialisationSubjects.find((c) => c.Id == subjectId);
      this.specialisations[index].ShowSubjectOthers =
        subject && subject.Name == "Others";
    },
    getSchoolQualifications(schoolId) {
      API.school
        .getSchoolQualifications({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.qualifications = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeQualification(event, index) {
      let qualificationId = event.target.value;
      let qualification = this.qualifications.find(
        (c) => c.Id == qualificationId
      );
      this.specialisations[index].ShowQualificationOthers =
        qualification && qualification.Name == "Others";
    },
    removeSpecialisation(index) {
      this.specialisations.splice(index, 1);
    },
    addSpecialisation() {
      this.specialisations.push({
        Id: "",
        SubjectId: "",
        SubjectOthers: "",
        ShowSubjectOthers: false,
        QualificationId: "",
        QualificationOthers: "",
        ShowQualificationOthers: false,
      });
    },
    //preferred teaching subject
    getTeachingSubjectsForInstructor(schoolId) {
      API.subject
        .getTeachingSubjectsForInstructor({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.teachingSubjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    removePreferredTeachingSubject(index) {
      this.preferredTeachingSubjects.splice(index, 1);
    },
    addPreferredTeachingSubject() {
      this.preferredTeachingSubjects.push({
        Id: "",
        SubjectId: "",
      });
    },
    //preferred teaching level
    getTeachingLevelsForInstructor(schoolId) {
      API.instructor
        .getTeachingLevelsForInstructor({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.teachingLevels = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCheckAllPreferredTeachingLevel(event) {
      this.checkAllPreferredTeachingLevel = event.target.checked;
      for (let teachingLevel of this.teachingLevels) {
        teachingLevel.IsSelected = this.checkAllPreferredTeachingLevel;
      }
    },
    onChangeCheckPreferredTeachingLevel() {
      let selectedTeachingLevels = this.teachingLevels.filter(
        (c) => c.IsSelected == true
      );
      this.checkAllPreferredTeachingLevel =
        selectedTeachingLevels.length == this.teachingLevels.length;
    },
    //preferred class duration
    getClassDurations() {
      API.class
        .getClassDurations({
          Token: this.tokenObj.Token,
        })
        .then((response) => {
          if (response.data.success) {
            this.durations = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeCheckAllPreferredDuration(event) {
      this.checkAllPreferredDuration = event.target.checked;
      for (let duration of this.durations) {
        duration.IsSelected = this.checkAllPreferredDuration;
      }
    },
    onChangeCheckPreferredDuration() {
      let selectedDurations = this.durations.filter(
        (c) => c.IsSelected == true
      );
      this.checkAllPreferredDuration =
        selectedDurations.length == this.durations.length;
    },
    //main function
    saveInstructor() {
      if (this.emails.length == 0) {
        this.$swal("Please add at least 1 email", { icon: "error" });
        return;
      }
      if (this.contactNumbers.length == 0) {
        this.$swal("Please add at least 1 contact number", { icon: "error" });
        return;
      }
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        UserTypeId: this.userTypeId,
        UserTypeOthers: this.userTypeOthers,
        JoinDateInput: this.joinDate,
        LengthOfService: this.lengthOfService,
        UserName: this.username,
        Password: this.password,
        Name: this.name,
        DateOfBirthInput: this.dateOfBirth,
        GenderId: this.genderId,
        GenderCustom: this.genderCustom,
        NationalityId: this.nationalityId,
        CitizenshipId: this.citizenshipId,
        CitizenshipOtherNationalityId: this.citizenshipOtherNationalityId,
        Countries: this.userCountries.map((c) => c.Id),
        DocumentNumber: this.documentNumber,
        MaritalStatusId: this.maritalStatusId,
        Emails: this.emails,
        Addresses: this.addresses,
        ContactNumbers: this.contactNumbers,
        Banks: this.banks,
        Specialisations: this.specialisations,
        PreferredTeachingSubjects: this.preferredTeachingSubjects,
        PreferredTeachingLevels: this.teachingLevels.filter(
          (c) => c.IsSelected == true
        ),
        PreferredClassDurations: this.durations.filter(
          (c) => c.IsSelected == true
        ),
        Status: this.status,
        Remarks: this.remarks,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the updated info for School Staff?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.instructor
            .saveInstructor(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success)
                this.$router.replace({
                  name:
                    this.tokenObj.UserType == this.userTypeMainAdmin
                      ? "mainAdminInstructorList"
                      : "schoolAdminInstructorList",
                });
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getInstructorDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.instructor
        .getInstructorDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let instructor = response.data.data;
            this.schoolId = instructor.SchoolId;
            this.getInstructorUserTypes(this.schoolId);
            this.getSpecialisationSubjectsForInstructor(this.schoolId);
            this.getSchoolQualifications(this.schoolId);
            this.getTeachingSubjectsForInstructor(this.schoolId);
            this.userTypeId = instructor.UserTypeId;
            this.joinDate = instructor.JoinDateCal;
            this.lengthOfService = instructor.LengthOfService;
            this.username = instructor.UserName;
            this.password = instructor.Password;
            this.name = instructor.Name;
            this.dateOfBirth = instructor.DateOfBirthCal;
            this.genderId = instructor.GenderId
              ? instructor.GenderId
              : this.genderId;
            this.genderCustom = instructor.GenderCustom;
            this.showGenderCustom = instructor.ShowGenderCustom;
            this.nationalityId = instructor.NationalityId
              ? instructor.NationalityId
              : this.nationalityId;
            this.citizenshipId = instructor.CitizenshipId
              ? instructor.CitizenshipId
              : this.citizenshipId;
            this.showCitizenshipOther = instructor.ShowCitizenshipOther;
            this.citizenshipOtherNationalityId =
              instructor.CitizenshipOtherNationalityId
                ? instructor.CitizenshipOtherNationalityId
                : this.citizenshipOtherNationalityId;
            this.userCountries = instructor.UserCountries;
            this.documentNumber = instructor.DocumentNumber;
            this.maritalStatusId = instructor.MaritalStatusId
              ? instructor.MaritalStatusId
              : this.maritalStatusId;
            this.emails = instructor.Emails;
            this.addresses = instructor.Addresses;
            this.contactNumbers = instructor.ContactNumbers;
            this.banks = instructor.Banks;
            this.specialisations = instructor.Specialisations;
            this.preferredTeachingSubjects =
              instructor.PreferredTeachingSubjects;
            this.teachingLevels = instructor.PreferredTeachingLevels;
            this.checkAllPreferredTeachingLevel =
              instructor.PreferredTeachingLevels.length ==
              instructor.PreferredTeachingLevels.filter(
                (c) => c.IsSelected == true
              ).length;
            this.durations = instructor.PreferredClassDurations;
            this.checkAllPreferredDuration =
              instructor.PreferredClassDurations.length ==
              instructor.PreferredClassDurations.filter(
                (c) => c.IsSelected == true
              ).length;
            this.status = instructor.Status;
            this.remarks = instructor.Remarks;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getSchools();
    this.getGenders();
    this.getNationalities();
    this.getCitizenships();
    this.getMaritalStatuses();
    this.getEmailTypesForInstructor();
    this.getAddressTypesForInstructor();
    this.getCountries();
    this.getContactNumberTypesForInstructor();
    this.getBankAccountTypes();

    if (!this.$route.params.id) {
      this.getClassDurations();
      if (this.tokenObj.UserType != this.userTypeMainAdmin) {
        this.getInstructorUserTypes(this.tokenObj.SchoolId);
        this.getSpecialisationSubjectsForInstructor(this.tokenObj.SchoolId);
        this.getSchoolQualifications(this.tokenObj.SchoolId);
        this.getTeachingSubjectsForInstructor(this.tokenObj.SchoolId);
        this.getTeachingLevelsForInstructor(this.tokenObj.SchoolId);
      }
    }
    if (this.$route.params.id) this.getInstructorDetail();
  },
};
</script>

<style scoped>
.id-div {
  padding-top: 9px;
}
.no-col {
  width: 40px;
  vertical-align: middle;
}
.type-col {
  width: 150px;
}
.action-col {
  width: 64px;
}
.postcode-col {
  width: 110px;
}
.table-responsive,
.table {
  margin-bottom: 0;
}
.bankname-col {
  width: 46.7%;
}
.specialisation-col,
.qualification-col {
  width: 42%;
}
.duration-table,
.teachinglevel-table {
  margin-top: 8px;
}
.duration-table td,
.teachinglevel-table td {
  padding-top: 0;
  padding-bottom: 0;
  border-top: none;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}
.duration-table tr:last-child td,
.teachinglevel-table tr:last-child td {
  border-bottom: 1px solid #dee2e6;
}
@media screen and (max-width: 767.98px) {
  .id-div {
    padding-top: 0px;
  }
  .email-table,
  .contact-table,
  .specialisation-table,
  .preferredteaching-table {
    width: 570px !important;
  }
  .duration-table,
  .teachinglevel-table {
    width: 367px !important;
  }
  .duration-table,
  .teachinglevel-table {
    margin-top: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/InstructorEdit.vue